module.exports = __webpack_public_path__ + "media/images/athletes/3434-23805e858ea7d648ef7d6d4ad82f597a.png";